<template>
  <div class="base-control base-text-area form-group" :class="{row: inline, 'error': hasErrors, 'ok': isOk, disabled: disabled }">
    <label :for="id" :class="{'col-form-label': inline, 'col-12': !inline, 'col-sm-4': inline}">{{ label }}</label>
    <div :class="{'position-relative': inline, 'col-12': !inline, 'col-sm-8': inline}">
      <textarea ref="input" :id="id" class="form-control" :style="{height: height}"
                :class="{[radius]: true, 'is-invalid': hasErrors}" :value="value" :disabled="disabled"
                @input="$emit('input', $event.target.value)"></textarea>
      <div class="invalid-feedback" :class="{'absolute-right-errors': (hasErrors && inline)}" v-if="err && err.length > 0">
        <p class="error mb-0" v-for="error in err" :key="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseTextArea',
  inject: ['$validator'],
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: 'auto'
    },
    label: {
      type: String,
      default: ''
    },
    radius: {
      type: String,
      default: ''
    },
    err: {
      type: Array,
      default: () => []
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  $_veeValidate: {
    value () {
      return this.$refs.input.value;
    },
    name () {
      return this.name;
    }
  },
  data () {
    return {

    };
  },
  mounted () {
    if (this.value !== null && this.value !== '') {
      this.$validator.validateAll();
    }
  },
  computed: {
    id () {
      return 'base-text-area-' + this._uid;
    },
    hasErrors () {
      return this.err && this.err.length > 0;
    },
    isOk () {
      let k = '';
      for (const key in this.fields) {
        k = key;
      }

      if (!this.fields[k] || !this.fields[k][this.name]) return false;
      return this.fields[k][this.name].validated && this.fields[k][this.name].valid;
    }
  },
  methods: {

  }
};

</script>

<style>

</style>
